module.exports = __webpack_public_path__ + "static/img/Brenda.9fe239d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/staff/Brenda.jpg
// module id = 198
// module chunks = 1